import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import Swal from 'sweetalert2';
import { userId, submitRequest } from '../../Api';
import 'react-datepicker/dist/react-datepicker.css';
import './RequestService.css';

// Sanitize input function to remove harmful content
function sanitizeInput(input) {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.body.textContent || "";
}

function Request() {
  const [formData, setFormData] = useState({
    keluhan: '',
    date: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value); // Sanitize the input
    setFormData((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prevData) => ({
      ...prevData,
      date,
    }));
  };

  const dataToSubmit = {
    ...formData,
    date: formData.date
      ? formData.date.getFullYear() + '-' +
        String(formData.date.getMonth() + 1).padStart(2, '0') + '-' +
        String(formData.date.getDate()).padStart(2, '0')
      : null,
    id_pelanggan: userId,
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitRequest(dataToSubmit);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Permintaan Anda telah terkirim!',
      });
      // Reset the form
      setFormData({
        keluhan: '',
        date: null,
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Terjadi Kesalahan, silahkan coba lagi.',
      });
    }
  };

  // Get tomorrow's date
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  return (
    <div className="request-service-form">
      <p className="required_text">
        Tanda <span className="required">*</span> Wajib diisi
      </p>
      <form onSubmit={handleSubmit}>
        <label className="label" htmlFor="keluhan">
          Keluhan AC <span className="required">*</span>
          <textarea
            id="keluhan"
            name="keluhan"
            value={formData.keluhan}
            onChange={handleChange}
            className="input-field message-field"
            placeholder="Contoh: Service Berkala"
            required
          ></textarea>
        </label>

        <label className="label" htmlFor="date">
          Tanggal dibutuhkan perbaikan <span className="required">*</span>
          <DatePicker
            selected={formData.date}
            onChange={handleDateChange}
            className="input-field"
            minDate={tomorrow} // Disable dates before tomorrow
            placeholderText="Pilih tanggal"
            dateFormat="dd/MM/yyyy"
            required
          />
        </label>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default Request;
